export function formatCentsToDollarString(cents: number = 0, precision = 2) {
  return (cents / 100).toFixed(precision);
}
